import React, {
  createContext, useContext, useEffect, useMemo,
} from 'react';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';
import {
  extractUserToken,
  isUnauthorizedPath,
} from '../services/AuthService';

interface Context {}

const AuthContext = createContext<Context>({});

function AuthProvider({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const navigate = useNavigate();
  const value = useMemo(() => ({}), [location, navigate]);

  useEffect(() => {
    if (isUnauthorizedPath(location)) {
      return;
    }

    const params = new URLSearchParams(location.search);
    extractUserToken(params, navigate);
  }, [location, navigate]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

function useAuthContext(): Context {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuthContext must be used within a AuthProvider');
  }

  return context;
}

export { useAuthContext, AuthProvider };
